'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.clearSid = clearSid;
exports.default = reducer;
exports.saveSid = saveSid;
exports.appleLogin = appleLogin;
exports.appleUpgrade = appleUpgrade;
exports.approveAgreements = approveAgreements;
exports.canLoad = canLoad;
exports.contactUs = contactUs;
exports.createAccount = createAccount;
exports.createAccountV2 = createAccountV2;
exports.userPassUpgrade = userPassUpgrade;
exports.emailExists = emailExists;
exports.facebookLogin = facebookLogin;
exports.facebookUpgrade = facebookUpgrade;
exports.googleUpgrade = googleUpgrade;
exports.forgotPassword = forgotPassword;
exports.googleLogin = googleLogin;
exports.linkIdentityToAccount = linkIdentityToAccount;
exports.linkSecureToken = linkSecureToken;
exports.linkSSOToken = linkSSOToken;
exports.load = load;
exports.mobileGetUser = mobileGetUser;
exports.login = login;
exports.logout = logout;
exports.marketingCommunicationPreferences = marketingCommunicationPreferences;
exports.setPassword = setPassword;
exports.createPassword = createPassword;
exports.startGracePeriod = startGracePeriod;
exports.editDropdown = editDropdown;
exports.editEmail = editEmail;
exports.editEmailMessageError = editEmailMessageError;
exports.editLanguage = editLanguage;
exports.editRememberMe = editRememberMe;
exports.qrLogin = qrLogin;
exports.editQrLoginState = editQrLoginState;
exports.editAutoGracePeriod = editAutoGracePeriod;
exports.editTermsAndPrivacy = editTermsAndPrivacy;
exports.forceChooseProvider = forceChooseProvider;
exports.setUtmParameters = setUtmParameters;
exports.setLocation = setLocation;
exports.tvFlowStarted = tvFlowStarted;

var _cookie = require('cookie');

var _cookie2 = _interopRequireDefault(_cookie);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _url = require('url');

var _url2 = _interopRequireDefault(_url);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _Cookie = require('../../helpers/Cookie');

var _Cookie2 = _interopRequireDefault(_Cookie);

var _URL = require('../../helpers/URL');

var _SegmentLogs = require('../../helpers/SegmentLogs');

var _SessionStorage = require('../../helpers/SessionStorage');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var APPLE_LOGIN = 'redux/auth/APPLE_LOGIN';
var APPLE_LOGIN_SUCCESS = 'redux/auth/APPLE_LOGIN_SUCCESS';
var APPLE_LOGIN_FAIL = 'redux/auth/APPLE_LOGIN_FAIL';
var APPROVE_AGREEMENTS = 'redux/auth/APPROVE_AGREEMENTS';
var APPROVE_AGREEMENTS_SUCCESS = 'redux/auth/APPROVE_AGREEMENTS_SUCCESS';
var APPROVE_AGREEMENTS_FAIL = 'redux/auth/APPROVE_AGREEMENTS_FAIL';
var AUTO_GRACE_PERIOD = 'redux/auth/AUTO_GRACE_PERIOD';
var CONTACT_US = 'redux/auth/CONTACT_US';
var CONTACT_US_SUCCESS = 'redux/auth/CONTACT_US_SUCCESS';
var CONTACT_US_FAIL = 'redux/auth/CONTACT_US_FAIL';
var CREATE_ACCOUNT = 'redux/auth/CREATE_ACCOUNT';
var CREATE_ACCOUNT_SUCCESS = 'redux/auth/CREATE_ACCOUNT_SUCCESS';
var CREATE_ACCOUNT_FAIL = 'redux/auth/CREATE_ACCOUNT_FAIL';
var DROPDOWN_VALUE = 'redux/auth/DROPDOWN_VALUE';
var EDIT_LANGUAGE = 'redux/auth/EDIT_LANGUAGE';
var EMAIL = 'redux/auth/EMAIL';
var EMAIL_ERROR_MESSAGE = 'redux/auth/EMAIL_ERROR_MESSAGE';
var EMAIL_EXISTS = 'redux/auth/EMAIL_EXISTS';
var EMAIL_EXISTS_SUCCESS = 'redux/auth/EMAIL_EXISTS_SUCCESS';
var EMAIL_EXISTS_FAIL = 'redux/auth/EMAIL_EXISTS_FAIL';
var FB_LOGIN = 'redux/auth/FB_LOGIN';
var FB_LOGIN_SUCCESS = 'redux/auth/FB_LOGIN_SUCCESS';
var FB_LOGIN_FAIL = 'redux/auth/FB_LOGIN_FAIL';
var FORCE_CHOOSE_PROVIDER = 'redux/auth/FORCE_CHOOSE_PROVIDER';
var FORGOT_PASSWORD = 'redux/auth/FORGOT_PASSWORD';
var FORGOT_PASSWORD_SUCCESS = 'redux/auth/FORGOT_PASSWORD_SUCCESS';
var FORGOT_PASSWORD_FAIL = 'redux/auth/FORGOT_PASSWORD_FAIL';
var GOOGLE_LOGIN = 'redux/auth/GOOGLE_LOGIN';
var GOOGLE_LOGIN_SUCCESS = 'redux/auth/GOOGLE_LOGIN_SUCCESS';
var GOOGLE_LOGIN_FAIL = 'redux/auth/GOOGLE_LOGIN_FAIL';
var LINK_IDENTITY_TO_ACCOUNT = 'redux/auth/LINK_IDENTITY_TO_ACCOUNT';
var LINK_IDENTITY_TO_ACCOUNT_SUCCESS = 'redux/auth/LINK_IDENTITY_TO_ACCOUNT_SUCCESS';
var LINK_IDENTITY_TO_ACCOUNT_FAIL = 'redux/auth/LINK_IDENTITY_TO_ACCOUNT_FAIL';
var LINK_SECURE_TOKEN = 'redux/auth/LINK_SECURE_TOKEN';
var LINK_SECURE_TOKEN_SUCCESS = 'redux/auth/LINK_SECURE_TOKEN_SUCCESS';
var LINK_SECURE_TOKEN_FAIL = 'redux/auth/LINK_SECURE_TOKEN_FAIL';
var LINK_SSO_TOKEN = 'redux/auth/LINK_SSO_TOKEN';
var LINK_SSO_TOKEN_SUCCESS = 'redux/auth/LINK_SSO_TOKEN_SUCCESS';
var LINK_SSO_TOKEN_FAIL = 'redux/auth/LINK_SSO_TOKEN_FAIL';
var LOAD = 'redux/auth/LOAD';
var LOAD_SUCCESS = 'redux/auth/LOAD_SUCCESS';
var LOAD_FAIL = 'redux/auth/LOAD_FAIL';
var LOGIN = 'redux/auth/LOGIN';
var LOGIN_SUCCESS = 'redux/auth/LOGIN_SUCCESS';
var LOGIN_FAIL = 'redux/auth/LOGIN_FAIL';
var LOGOUT = 'redux/auth/LOGOUT';
var LOGOUT_SUCCESS = 'redux/auth/LOGOUT_SUCCESS';
var LOGOUT_FAIL = 'redux/auth/LOGOUT_FAIL';
var MARKETING_COMMUNICATION_PREF = 'redux/auth/MARKETING_COMMUNICATION_PREF';
var MARKETING_COMMUNICATION_PREF_SUCCESS = 'redux/auth/MARKETING_COMMUNICATION_PREF_SUCCESS';
var MARKETING_COMMUNICATION_PREF_FAIL = 'redux/auth/MARKETING_COMMUNICATION_PREF_FAIL';
var MOBILE_GET_USER = 'redux/auth/MOBILE_GET_USER';
var MOBILE_GET_USER_SUCCESS = 'redux/auth/MOBILE_GET_USER_SUCCESS';
var MOBILE_GET_USER_FAIL = 'redux/auth/MOBILE_GET_USER_FAIL';
var QR_LOGIN = 'redux/auth/QR_LOGIN';
var QR_LOGIN_STATE = 'redux/auth/QR_LOGIN_STATE';
var REMEMBER_ME = 'redux/auth/REMEMBER_ME';
var SAVE_SESSION_ID = 'redux/auth/SAVE_SESSION_ID';
var SET_PASSWORD = 'redux/auth/SET_PASSWORD';
var SET_PASSWORD_SUCCESS = 'redux/auth/SET_PASSWORD_SUCCESS';
var SET_PASSWORD_FAIL = 'redux/auth/SET_PASSWORD_FAIL';
var SET_UTM_PARAMETERS = 'redux/auth/SET_UTM_PARAMETERS';
var SET_LOCATION = 'redux/auth/SET_LOCATION';
var CREATE_PASSWORD = 'redux/auth/CREATE_PASSWORD';
var CREATE_PASSWORD_SUCCESS = 'redux/auth/CREATE_PASSWORD_SUCCESS';
var CREATE_PASSWORD_FAIL = 'CREATE_PASSWORD_FAIL';
var START_GRACE_PERIOD = 'redux/auth/START_GRACE_PERIOD';
var START_GRACE_PERIOD_SUCCESS = 'redux/auth/START_GRACE_PERIOD_SUCCESS';
var START_GRACE_PERIOD_FAIL = 'redux/auth/START_GRACE_PERIOD_FAIL';
var TERMS_PRIVACY = 'redux/auth/TERMS_PRIVACY';
var TV_FLOW_STARTED = 'redux/auth/TV_FLOW_STARTED';

var initialState = {
  clientId: '',
  dropdownValue: '',
  email: '',
  emailErrorMessage: '',
  initLang: 'en',
  loaded: false,
  lang: 'en',
  countryCode: 'US',
  productName: '',
  realm: '',
  rememberMe: true,
  termsPrivacy: false,
  userInfo: null,
  utmParameters: '',
  sessionId: null
};

function clearSid(auth) {
  var deprecatedSidCookie = _cookie2.default.serialize((0, _Cookie2.default)(_config2.default.envPrefix, _Cookie.deprecatedSessionIdName, auth.realm), '', { expires: new Date(0), path: _Cookie.rootPath }); // Clear deprecated cookie
  var universalLoginSidCookie = _cookie2.default.serialize((0, _Cookie2.default)(_config2.default.envPrefix, _Cookie.loginSessionIdName, auth.realm), '', { expires: new Date(0), domain: (0, _Cookie.getCookieDomain)(), path: _Cookie.rootPath });
  var universalLoginLastLoginTimeCookie = _cookie2.default.serialize((0, _Cookie2.default)(_config2.default.envPrefix, _Cookie.lastLoginLogoutTime, auth.realm), new Date().getTime(), {
    expires: new Date((0, _moment2.default)().add(5, 'years').toDate()),
    domain: (0, _Cookie.getCookieDomain)(),
    path: _Cookie.rootPath
  });

  document.cookie = deprecatedSidCookie;
  document.cookie = universalLoginSidCookie;
  document.cookie = universalLoginLastLoginTimeCookie;
  return { type: SAVE_SESSION_ID, sessionId: '' };
}

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case APPLE_LOGIN:
      return (0, _extends3.default)({}, state, {
        appleLoggingIn: true,
        sessionId: null,
        userInfo: null,
        error: null
      });
    case APPLE_LOGIN_SUCCESS:
      return (0, _extends3.default)({}, state, {
        appleLoggingIn: false,
        sessionId: action.result.obj.sessionId,
        userInfo: action.result.obj.userInfo
      });
    case APPLE_LOGIN_FAIL:
      return (0, _extends3.default)({}, state, {
        appleLoggingIn: false,
        error: action.error.errObj
      });
    case APPROVE_AGREEMENTS:
      return (0, _extends3.default)({}, state, {
        gettingApproveAgreements: true,
        userInfo: null
      });
    case APPROVE_AGREEMENTS_SUCCESS:
      return (0, _extends3.default)({}, state, {
        gettingApproveAgreements: false,
        userInfo: action.result.obj
      });
    case APPROVE_AGREEMENTS_FAIL:
      return (0, _extends3.default)({}, state, {
        gettingApproveAgreements: false,
        error: action.error.errObj
      });
    case AUTO_GRACE_PERIOD:
      return (0, _extends3.default)({}, state, {
        autoGracePeriod: action.value
      });
    case CREATE_ACCOUNT:
      return (0, _extends3.default)({}, state, {
        creatingAccount: true,
        sessionId: null,
        userInfo: null,
        error: null
      });
    case CREATE_ACCOUNT_SUCCESS:
      return (0, _extends3.default)({}, state, {
        creatingAccount: false,
        sessionId: action.result.obj.sessionId,
        userInfo: action.result.obj.userInfo
      });
    case CREATE_ACCOUNT_FAIL:
      return (0, _extends3.default)({}, state, {
        creatingAccount: false,
        error: action.error.errObj
      });
    case CREATE_PASSWORD:
      return (0, _extends3.default)({}, state, {
        creatingPassword: true,
        error: null
      });
    case CREATE_PASSWORD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        creatingPassword: false
      });
    case CREATE_PASSWORD_FAIL:
      return (0, _extends3.default)({}, state, {
        creatingPassword: false,
        error: action.error.errObj
      });
    case CONTACT_US:
      return (0, _extends3.default)({}, state, {
        sendingContactUs: true,
        success: false,
        error: null
      });
    case CONTACT_US_SUCCESS:
      return (0, _extends3.default)({}, state, {
        sendingContactUs: false,
        success: true
      });
    case CONTACT_US_FAIL:
      return (0, _extends3.default)({}, state, {
        sendingContactUs: false,
        success: false,
        error: action.error
      });
    case DROPDOWN_VALUE:
      return (0, _extends3.default)({}, state, {
        dropdownValue: action.value
      });
    case FB_LOGIN:
      return (0, _extends3.default)({}, state, {
        fbLoggingIn: true,
        sessionId: null,
        userInfo: null,
        error: null
      });
    case FB_LOGIN_SUCCESS:
      return (0, _extends3.default)({}, state, {
        fbLoggingIn: false,
        sessionId: action.result.obj.sessionId,
        userInfo: action.result.obj.userInfo
      });
    case FB_LOGIN_FAIL:
      return (0, _extends3.default)({}, state, {
        fbLoggingIn: false,
        error: action.error.errObj
      });
    case FORCE_CHOOSE_PROVIDER:
      return (0, _extends3.default)({}, state, {
        forceChooseProvider: action.value
      });
    case FORGOT_PASSWORD:
      return (0, _extends3.default)({}, state, {
        forgotPassword: true,
        forgotPasswordError: null,
        response: null
      });
    case FORGOT_PASSWORD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        forgotPassword: false,
        response: action.result.obj
      });
    case FORGOT_PASSWORD_FAIL:
      return (0, _extends3.default)({}, state, {
        forgotPassword: false,
        forgotPasswordError: action.error.errObj
      });
    case GOOGLE_LOGIN:
      return (0, _extends3.default)({}, state, {
        googleLoggingIn: true,
        sessionId: null,
        userInfo: null,
        error: null
      });
    case GOOGLE_LOGIN_SUCCESS:
      return (0, _extends3.default)({}, state, {
        googleLoggingIn: false,
        sessionId: action.result.obj.sessionId,
        userInfo: action.result.obj.userInfo
      });
    case GOOGLE_LOGIN_FAIL:
      return (0, _extends3.default)({}, state, {
        googleLoggingIn: false,
        error: action.error.errObj
      });
    case LINK_IDENTITY_TO_ACCOUNT:
      return (0, _extends3.default)({}, state, {
        linkingIdentityToAccount: true,
        userInfo: null,
        error: null
      });
    case LINK_IDENTITY_TO_ACCOUNT_SUCCESS:
      return (0, _extends3.default)({}, state, {
        linkingIdentityToAccount: false,
        userInfo: action.result.obj
      });
    case LINK_IDENTITY_TO_ACCOUNT_FAIL:
      return (0, _extends3.default)({}, state, {
        linkingIdentityToAccount: false,
        error: action.error.errObj
      });
    case LINK_SECURE_TOKEN:
      return (0, _extends3.default)({}, state, {
        linkingSecureToken: true,
        userInfo: null,
        error: null
      });
    case LINK_SECURE_TOKEN_SUCCESS:
      return (0, _extends3.default)({}, state, {
        linkingSecureToken: false,
        userInfo: action.result.obj
      });
    case LINK_SECURE_TOKEN_FAIL:
      return (0, _extends3.default)({}, state, {
        linkingSecureToken: false,
        error: action.error.errObj
      });
    case LINK_SSO_TOKEN:
      return (0, _extends3.default)({}, state, {
        linkingSSOToken: true,
        userInfo: null,
        error: null
      });
    case LINK_SSO_TOKEN_SUCCESS:
      return (0, _extends3.default)({}, state, {
        linkingSSOToken: false,
        userInfo: action.result.obj
      });
    case LINK_SSO_TOKEN_FAIL:
      return (0, _extends3.default)({}, state, {
        linkingSSOToken: false,
        userInfo: null,
        error: action.error.errObj
      });
    case LOAD:
      return (0, _extends3.default)({}, state);
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loaded: true,
        userInfo: action.result.obj
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loaded: false,
        error: action.error.obj
      });
    case LOGIN:
      return (0, _extends3.default)({}, state, {
        loggingIn: true,
        sessionId: null,
        userInfo: null,
        loginError: null,
        error: null
      });
    case LOGIN_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loggingIn: false,
        sessionId: action.result.obj.sessionId,
        userInfo: action.result.obj.userInfo
      });
    case LOGIN_FAIL:
      return (0, _extends3.default)({}, state, {
        loggingIn: false,
        loginError: action.error.errObj
      });
    case LOGOUT:
      return (0, _extends3.default)({}, state, {
        loggingOut: true
      });
    case LOGOUT_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loggingOut: false,
        sessionId: null
      });
    case LOGOUT_FAIL:
      return (0, _extends3.default)({}, state, {
        loggingOut: false,
        logoutError: action.error.obj,
        sessionId: null
      });
    case MARKETING_COMMUNICATION_PREF:
      return (0, _extends3.default)({}, state, {
        sendingCommunicationPref: true,
        error: null,
        userInfo: null
      });
    case MARKETING_COMMUNICATION_PREF_SUCCESS:
      return (0, _extends3.default)({}, state, {
        sendingCommunicationPref: false,
        userInfo: action.result.obj
      });
    case MARKETING_COMMUNICATION_PREF_FAIL:
      return (0, _extends3.default)({}, state, {
        sendingCommunicationPref: false,
        error: action.error.errObj
      });
    case MOBILE_GET_USER:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case MOBILE_GET_USER_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loaded: true,
        loading: false,
        userInfo: action.result.obj
      });
    case MOBILE_GET_USER_FAIL:
      return (0, _extends3.default)({}, state, {
        loaded: false,
        loading: false,
        error: action.error.obj
      });
    case QR_LOGIN:
      return (0, _extends3.default)({}, state, {
        sessionId: action.response.sessionId,
        userInfo: action.response.userInfo,
        qrLogin: true
      });
    case QR_LOGIN_STATE:
      return (0, _extends3.default)({}, state, {
        qrLogin: action.value
      });
    case SET_PASSWORD:
      return (0, _extends3.default)({}, state, {
        setPassword: true,
        setPasswordError: null,
        response: null
      });
    case SET_PASSWORD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        setPassword: false,
        response: action.result.obj
      });
    case SET_PASSWORD_FAIL:
      return (0, _extends3.default)({}, state, {
        setPassword: false,
        setPasswordError: action.error.errObj
      });
    case START_GRACE_PERIOD:
      return (0, _extends3.default)({}, state, {
        startingGracePeriod: true
      });
    case START_GRACE_PERIOD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        startingGracePeriod: false,
        userInfo: action.result.obj
      });
    case START_GRACE_PERIOD_FAIL:
      return (0, _extends3.default)({}, state, {
        startingGracePeriod: false,
        error: action.error.obj
      });
    case EDIT_LANGUAGE:
      return (0, _extends3.default)({}, state, {
        lang: action.lang
      });
    case EMAIL:
      return (0, _extends3.default)({}, state, {
        email: action.value
      });
    case EMAIL_ERROR_MESSAGE:
      return (0, _extends3.default)({}, state, {
        emailErrorMessage: action.value
      });
    case EMAIL_EXISTS:
      return (0, _extends3.default)({}, state, {
        emailExists: true,
        response: null,
        error: null
      });
    case EMAIL_EXISTS_SUCCESS:
      return (0, _extends3.default)({}, state, {
        emailExists: false,
        response: action.result.obj
      });
    case EMAIL_EXISTS_FAIL:
      return (0, _extends3.default)({}, state, {
        emailExists: false,
        error: action.error.errObj
      });
    case REMEMBER_ME:
      return (0, _extends3.default)({}, state, {
        rememberMe: action.value
      });
    case SAVE_SESSION_ID:
      return (0, _extends3.default)({}, state, {
        sessionId: action.sessionId
      });
    case TERMS_PRIVACY:
      return (0, _extends3.default)({}, state, {
        termsPrivacy: action.value
      });
    case SET_UTM_PARAMETERS:
      return (0, _extends3.default)({}, state, {
        utmParameters: action.utmParameters
      });
    case SET_LOCATION:
      return (0, _extends3.default)({}, state, {
        location: action.location
      });
    case TV_FLOW_STARTED:
      return (0, _extends3.default)({}, state, {
        tvCode: action.tvCode,
        clientId: action.clientId,
        sessionId: action.sessionId
      });
    default:
      return state;
  }
}

function saveSid(auth, sessionId) {
  var sidCookie = void 0;
  if (auth.rememberMe) {
    var expireDate = new Date((0, _moment2.default)().add(2, 'years').toDate());
    sidCookie = _cookie2.default.serialize((0, _Cookie2.default)(_config2.default.envPrefix, _Cookie.loginSessionIdName, auth.realm), sessionId, { expires: expireDate, domain: (0, _Cookie.getCookieDomain)(), secure: _config2.default.isSecured, path: _Cookie.rootPath });
  } else {
    // Cookie saved only for the session.
    sidCookie = _cookie2.default.serialize((0, _Cookie2.default)(_config2.default.envPrefix, _Cookie.loginSessionIdName, auth.realm), sessionId, { secure: _config2.default.isSecured, domain: (0, _Cookie.getCookieDomain)(), path: _Cookie.rootPath });
  }
  var universalLoginLastLoginTimeCookie = _cookie2.default.serialize((0, _Cookie2.default)(_config2.default.envPrefix, _Cookie.lastLoginLogoutTime, auth.realm), new Date().getTime(), {
    expires: new Date((0, _moment2.default)().add(5, 'years').toDate()),
    domain: (0, _Cookie.getCookieDomain)(),
    path: _Cookie.rootPath
  });

  document.cookie = sidCookie;
  document.cookie = universalLoginLastLoginTimeCookie;
  return { type: SAVE_SESSION_ID, sessionId: sessionId };
}

function appleLogin(authorizationCode, language, applePasswordUri) {
  return function (dispatch, getState) {
    return dispatch({
      types: [APPLE_LOGIN, APPLE_LOGIN_SUCCESS, APPLE_LOGIN_FAIL],
      promise: function promise(createLoginClient) {
        return createLoginClient().then(function (loginClient) {
          return loginClient.user.appleLogin({
            deviceId: (0, _Cookie.readAndSaveDeviceId)(_config2.default.envPrefix, getState().auth.realm),
            languageTag: language,
            clientId: getState().auth.clientId,
            authorizationCode: authorizationCode,
            applePasswordUri: applePasswordUri
          }, { responseContentType: 'application/json' });
        }).then(function (result) {
          (0, _SegmentLogs.identify)(result.obj.userInfo.suid || result.obj.userInfo.loginId, (0, _extends3.default)({}, result.obj.userInfo));
          saveSid(getState().auth, result.obj.sessionId);
          return result;
        });
      }
    });
  };
}

function appleUpgrade(authorizationCode, language, applePasswordUri, sessionId) {
  return function (dispatch, getState) {
    return dispatch({
      types: [APPLE_LOGIN, APPLE_LOGIN_SUCCESS, APPLE_LOGIN_FAIL],
      promise: function promise(createLoginClient) {
        return createLoginClient().then(function (loginClient) {
          return loginClient.user.appleUpgrade({
            deviceId: (0, _Cookie.readAndSaveDeviceId)(_config2.default.envPrefix, getState().auth.realm),
            languageTag: language,
            clientId: getState().auth.clientId,
            authorizationCode: authorizationCode,
            applePasswordUri: applePasswordUri,
            sessionId: sessionId,
            termsAndConditions: true
          }, { responseContentType: 'application/json' });
        }).then(function (result) {
          (0, _SegmentLogs.identify)(result.obj.userInfo.suid || result.obj.userInfo.loginId, (0, _extends3.default)({}, result.obj.userInfo));
          saveSid(getState().auth, result.obj.sessionId);
          return result;
        });
      }
    });
  };
}

function approveAgreements() {
  return function (dispatch, getState) {
    return dispatch({
      types: [APPROVE_AGREEMENTS, APPROVE_AGREEMENTS_SUCCESS, APPROVE_AGREEMENTS_FAIL],
      promise: function promise(createLoginClient) {
        return createLoginClient().then(function (loginClient) {
          var auth = getState().auth;
          return loginClient.agreements.approve({ sessionId: auth.sessionId, languageTag: auth.lang, clientId: auth.clientId }, { responseContentType: 'application/json' });
        }).then(function (result) {
          return result;
        });
      }
    });
  };
}

function canLoad(globalState) {
  return globalState.auth && !globalState.auth.loaded && globalState.auth.sessionId;
}

function contactUs(category, comments, version, contactUsSrc) {
  return function (dispatch, getState) {
    return dispatch({
      types: [CONTACT_US, CONTACT_US_SUCCESS, CONTACT_US_FAIL],
      promise: function promise(createLoginClient) {
        return createLoginClient().then(function (loginClient) {
          var auth = getState().auth;
          var complementaryInfo = {
            source: contactUsSrc,
            deviceId: (0, _Cookie.readAndSaveDeviceId)(_config2.default.envPrefix, auth.realm),
            universalLoginFEVersion: version,
            languageTag: auth.lang
          };
          var email = auth.email;
          if (!email && auth.userInfo && auth.userInfo.account && auth.userInfo.account.emailAddress) {
            email = auth.userInfo.account.emailAddress;
          }
          return loginClient.support.contactUs({
            userEmail: email,
            categoryKey: category,
            userComments: comments,
            clientId: auth.clientId,
            sessionId: auth.sessionId,
            complementaryInfo: (0, _stringify2.default)(complementaryInfo)
          }, { responseContentType: 'application/json' });
        }).then(function (result) {
          return result;
        });
      }
    });
  };
}

// DEPRECATED in favor of createAccountV2
function createAccount(email, password) {
  return function (dispatch, getState) {
    return dispatch({
      types: [CREATE_ACCOUNT, CREATE_ACCOUNT_SUCCESS, CREATE_ACCOUNT_FAIL],
      promise: function promise(createLoginClient) {
        return createLoginClient().then(function (loginClient) {
          var auth = getState().auth;
          return loginClient.user.userpassCreate({
            deviceId: (0, _Cookie.readAndSaveDeviceId)(_config2.default.envPrefix, auth.realm),
            email: email,
            password: password,
            languageTag: auth.lang,
            captchaKey: getState().captcha.captchaToken,
            clientId: auth.clientId,
            utmParameters: auth.utmParameters
          }, { responseContentType: 'application/json' });
        }).then(function (result) {
          (0, _SegmentLogs.identify)(result.obj.userInfo.suid || result.obj.userInfo.loginId, (0, _extends3.default)({}, result.obj.userInfo));
          saveSid(getState().auth, result.obj.sessionId);
          return result;
        });
      }
    });
  };
}

function createAccountV2(email, password) {
  return function (dispatch, getState) {
    return dispatch({
      types: [CREATE_ACCOUNT, CREATE_ACCOUNT_SUCCESS, CREATE_ACCOUNT_FAIL],
      promise: function promise(createLoginClient) {
        return createLoginClient().then(function (loginClient) {
          var auth = getState().auth;
          return loginClient.user.userpassCreateIfNotExists({
            email: email,
            password: password,
            languageTag: auth.lang,
            captchaKey: getState().captcha.captchaToken,
            clientId: auth.clientId,
            deviceId: (0, _Cookie.readAndSaveDeviceId)(_config2.default.envPrefix, auth.realm),
            utmParameters: auth.utmParameters
          }, { responseContentType: 'application/json' });
        }).then(function (result) {
          (0, _SegmentLogs.identify)(result.obj.userInfo.suid || result.obj.userInfo.loginId, (0, _extends3.default)({}, result.obj.userInfo));
          saveSid(getState().auth, result.obj.sessionId);
          return result;
        });
      }
    });
  };
}

function userPassUpgrade(sessionId, email, password) {
  return function (dispatch, getState) {
    return dispatch({
      types: [CREATE_ACCOUNT, CREATE_ACCOUNT_SUCCESS, CREATE_ACCOUNT_FAIL],
      promise: function promise(createLoginClient) {
        return createLoginClient().then(function (loginClient) {
          var auth = getState().auth;
          return loginClient.user.userPassUpgrade({
            sessionId: sessionId,
            email: email,
            password: password,
            languageTag: auth.lang,
            captchaKey: getState().captcha.captchaToken,
            clientId: auth.clientId,
            deviceId: (0, _Cookie.readAndSaveDeviceId)(_config2.default.envPrefix, auth.realm),
            termsAndConditions: true
          }, { responseContentType: 'application/json' });
        }).then(function (result) {
          (0, _SegmentLogs.identify)(result.obj.userInfo.suid || result.obj.userInfo.loginId, (0, _extends3.default)({}, result.obj.userInfo));
          saveSid(getState().auth, result.obj.sessionId);
          return result;
        });
      }
    });
  };
}

function emailExists(email) {
  return function (dispatch, getState) {
    return dispatch({
      types: [EMAIL_EXISTS, EMAIL_EXISTS_SUCCESS, EMAIL_EXISTS_FAIL],
      promise: function promise(createLoginClient) {
        return createLoginClient().then(function (loginClient) {
          var auth = getState().auth;
          return loginClient.user.emailExists({ email: email, captchaKey: getState().captcha.captchaToken, clientId: auth.clientId }, { responseContentType: 'application/json' });
        }).then(function (result) {
          return result;
        });
      }
    });
  };
}

function facebookLogin(accessToken, language, setFacebookPasswordUri) {
  return function (dispatch, getState) {
    return dispatch({
      types: [FB_LOGIN, FB_LOGIN_SUCCESS, FB_LOGIN_FAIL],
      promise: function promise(createLoginClient) {
        return createLoginClient().then(function (loginClient) {
          return loginClient.user.facebookLogin({
            deviceId: (0, _Cookie.readAndSaveDeviceId)(_config2.default.envPrefix, getState().auth.realm),
            facebookAccessToken: accessToken,
            languageTag: language,
            clientId: getState().auth.clientId,
            setFacebookPasswordUri: setFacebookPasswordUri,
            utmParameters: getState().auth.utmParameters
          }, { responseContentType: 'application/json' });
        }).then(function (result) {
          (0, _SegmentLogs.identify)(result.obj.userInfo.suid || result.obj.userInfo.loginId, (0, _extends3.default)({}, result.obj.userInfo));
          saveSid(getState().auth, result.obj.sessionId);
          return result;
        });
      }
    });
  };
}

function facebookUpgrade(accessToken, language, setFacebookPasswordUri, sessionId) {
  return function (dispatch, getState) {
    return dispatch({
      types: [FB_LOGIN, FB_LOGIN_SUCCESS, FB_LOGIN_FAIL],
      promise: function promise(createLoginClient) {
        return createLoginClient().then(function (loginClient) {
          return loginClient.user.facebookUpgrade({
            deviceId: (0, _Cookie.readAndSaveDeviceId)(_config2.default.envPrefix, getState().auth.realm),
            facebookAccessToken: accessToken,
            languageTag: language,
            clientId: getState().auth.clientId,
            setFacebookPasswordUri: setFacebookPasswordUri,
            utmParameters: getState().auth.utmParameters,
            sessionId: sessionId,
            termsAndConditions: true
          }, { responseContentType: 'application/json' });
        }).then(function (result) {
          (0, _SegmentLogs.identify)(result.obj.userInfo.suid || result.obj.userInfo.loginId, (0, _extends3.default)({}, result.obj.userInfo));
          saveSid(getState().auth, result.obj.sessionId);
          return result;
        });
      }
    });
  };
}

function googleUpgrade(googleCode, language, setGooglePasswordUri, sessionId) {
  return function (dispatch, getState) {
    return dispatch({
      types: [GOOGLE_LOGIN, GOOGLE_LOGIN_SUCCESS, GOOGLE_LOGIN_FAIL],
      promise: function promise(createLoginClient) {
        return createLoginClient().then(function (loginClient) {
          return loginClient.user.googleUpgrade({
            deviceId: (0, _Cookie.readAndSaveDeviceId)(_config2.default.envPrefix, getState().auth.realm),
            googleCode: googleCode,
            languageTag: language,
            clientId: getState().auth.clientId,
            setGooglePasswordUri: setGooglePasswordUri,
            utmParameters: getState().auth.utmParameters,
            sessionId: sessionId,
            termsAndConditions: true
          }, { responseContentType: 'application/json' });
        }).then(function (result) {
          (0, _SegmentLogs.identify)(result.obj.userInfo.suid || result.obj.userInfo.loginId, (0, _extends3.default)({}, result.obj.userInfo));
          saveSid(getState().auth, result.obj.sessionId);
          return result;
        });
      }
    });
  };
}

function forgotPassword(email, language, resetPasswordUrl) {
  return function (dispatch, getState) {
    return dispatch({
      types: [FORGOT_PASSWORD, FORGOT_PASSWORD_SUCCESS, FORGOT_PASSWORD_FAIL],
      promise: function promise(createLoginClient) {
        return createLoginClient().then(function (loginClient) {
          return loginClient.user.forgotPassword({
            email: email,
            captchaKey: getState().captcha.captchaToken,
            languageTag: language,
            clientId: getState().auth.clientId,
            resetPasswordUrl: resetPasswordUrl
          }, { responseContentType: 'application/json' });
        }).then(function (result) {
          return result;
        });
      }
    });
  };
}

function googleLogin(googleCode, language, setGooglePasswordUri) {
  return function (dispatch, getState) {
    return dispatch({
      types: [GOOGLE_LOGIN, GOOGLE_LOGIN_SUCCESS, GOOGLE_LOGIN_FAIL],
      promise: function promise(createLoginClient) {
        return createLoginClient().then(function (loginClient) {
          return loginClient.user.googleLoginWithCode({
            deviceId: (0, _Cookie.readAndSaveDeviceId)(_config2.default.envPrefix, getState().auth.realm),
            googleCode: googleCode,
            languageTag: language,
            clientId: getState().auth.clientId,
            setGooglePasswordUri: setGooglePasswordUri,
            utmParameters: getState().auth.utmParameters
          }, { responseContentType: 'application/json' });
        }).then(function (result) {
          (0, _SegmentLogs.identify)(result.obj.userInfo.suid || result.obj.userInfo.loginId, (0, _extends3.default)({}, result.obj.userInfo));
          saveSid(getState().auth, result.obj.sessionId);
          return result;
        });
      }
    });
  };
}

function linkIdentityToAccount(oldSessionId) {
  return function (dispatch, getState) {
    return dispatch({
      types: [LINK_IDENTITY_TO_ACCOUNT, LINK_IDENTITY_TO_ACCOUNT_SUCCESS, LINK_IDENTITY_TO_ACCOUNT_FAIL],
      promise: function promise(createLoginClient) {
        return createLoginClient().then(function (loginClient) {
          var auth = getState().auth;
          return loginClient.subscription.linkIdentityToAccount({
            sessionId: auth.sessionId,
            oldSessionId: oldSessionId,
            languageTag: auth.lang,
            clientId: auth.clientId
          }, { responseContentType: 'application/json' });
        }).then(function (result) {
          (0, _SessionStorage.saveDataInSessionStorage)(_SessionStorage.SessionStorageKeys.OldSessionId, '');
          return result;
        });
      }
    });
  };
}

function linkSecureToken(token, operatorId) {
  return function (dispatch, getState) {
    return dispatch({
      types: [LINK_SECURE_TOKEN, LINK_SECURE_TOKEN_SUCCESS, LINK_SECURE_TOKEN_FAIL],
      promise: function promise(createLoginClient) {
        return createLoginClient().then(function (loginClient) {
          var auth = getState().auth;
          return loginClient.subscription.linkSecureToken({
            sessionId: auth.sessionId,
            token: token,
            operatorId: operatorId,
            languageTag: auth.lang,
            clientId: auth.clientId,
            deviceId: (0, _Cookie.readAndSaveDeviceId)(_config2.default.envPrefix, auth.realm)
          }, { responseContentType: 'application/json' });
        }).then(function (result) {
          _URL.URL.removeUnusedParam();
          return result;
        });
      }
    });
  };
}

function linkSSOToken(token, operatorId) {
  return function (dispatch, getState) {
    return dispatch({
      types: [LINK_SSO_TOKEN, LINK_SSO_TOKEN_SUCCESS, LINK_SSO_TOKEN_FAIL],
      promise: function promise(createLoginClient) {
        return createLoginClient().then(function (loginClient) {
          var auth = getState().auth;
          return loginClient.subscription.linkSSO({
            sessionId: auth.sessionId,
            token: token,
            operatorId: operatorId,
            languageTag: auth.lang,
            clientId: auth.clientId,
            deviceId: (0, _Cookie.readAndSaveDeviceId)(_config2.default.envPrefix, auth.realm)
          }, { responseContentType: 'application/json' });
        }).then(function (result) {
          _URL.URL.removeUnusedParam();
          return result;
        });
      }
    });
  };
}

function load() {
  return function (dispatch, getState) {
    return dispatch({
      types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
      promise: function promise(createLoginClient) {
        return createLoginClient().then(function (loginClient) {
          var auth = getState().auth;
          return loginClient.user.get({ sessionId: auth.sessionId, languageTag: auth.lang, clientId: auth.clientId }, { responseContentType: 'application/json' });
        });
      }
    });
  };
}

/* We want a different function from load() to trigger MOBILE_GET_USER_FAIL, which changes
the "loading" field, triggering the componentWillReceiveProps in AuthorizationMobile.js,
which calls loadAuth() (and subsequently LOAD_FAIL) via App.js on reroute. We will end
up calling the API twice, but we avoid falling into a loop due to LOAD_FAIL no longer
handling the "loading" field. */

function mobileGetUser() {
  return function (dispatch, getState) {
    return dispatch({
      types: [MOBILE_GET_USER, MOBILE_GET_USER_SUCCESS, MOBILE_GET_USER_FAIL],
      promise: function promise(createLoginClient) {
        return createLoginClient().then(function (loginClient) {
          var auth = getState().auth;
          return loginClient.user.get({ sessionId: auth.sessionId, languageTag: auth.lang, clientId: auth.clientId }, { responseContentType: 'application/json' });
        });
      }
    });
  };
}

function login(email, password, language, captchaResponse) {
  return function (dispatch, getState) {
    return dispatch({
      types: [LOGIN, LOGIN_SUCCESS, LOGIN_FAIL],
      promise: function promise(createLoginClient) {
        return createLoginClient().then(function (loginClient) {
          var auth = getState().auth;
          return loginClient.user.userpassLogin({
            email: email,
            password: password,
            languageTag: language,
            captchaKey: captchaResponse,
            clientId: getState().auth.clientId,
            deviceId: (0, _Cookie.readAndSaveDeviceId)(_config2.default.envPrefix, auth.realm),
            utmParameters: getState().auth.utmParameters
          }, { responseContentType: 'application/json' }).then(function (result) {
            (0, _SegmentLogs.identify)(result.obj.userInfo.suid || result.obj.userInfo.loginId, (0, _extends3.default)({}, result.obj.userInfo));
            saveSid(getState().auth, result.obj.sessionId);
            return result;
          });
        });
      }
    });
  };
}

function logout() {
  return function (dispatch, getState) {
    return dispatch({
      types: [LOGOUT, LOGOUT_SUCCESS, LOGOUT_FAIL],
      promise: function promise(createLoginClient) {
        return createLoginClient().then(function (loginClient) {
          var auth = getState().auth;
          var query = _url2.default.parse(window.location.href, true).query;
          return loginClient.user.logout({
            sessionId: auth.sessionId,
            deviceId: (0, _Cookie.readAndSaveDeviceId)(_config2.default.envPrefix, auth.realm),
            clientId: auth.clientId
          }, { responseContentType: 'application/json' }).then(function (result) {
            clearSid(auth);
            window.location.replace(query.redirect_uri);
            return result;
          }).catch(function (error) {
            clearSid(auth);
            window.location.replace(query.redirect_uri);
            return error;
          });
        });
      }
    });
  };
}

function marketingCommunicationPreferences(isOptIn) {
  return function (dispatch, getState) {
    return dispatch({
      types: [MARKETING_COMMUNICATION_PREF, MARKETING_COMMUNICATION_PREF_SUCCESS, MARKETING_COMMUNICATION_PREF_FAIL],
      promise: function promise(createLoginClient) {
        return createLoginClient().then(function (loginClient) {
          var auth = getState().auth;
          return loginClient.marketing.communicationPreferences({
            sessionId: auth.sessionId,
            deviceId: (0, _Cookie.readAndSaveDeviceId)(_config2.default.envPrefix, auth.realm),
            languageTag: auth.lang,
            clientId: auth.clientId,
            isOptIn: isOptIn,
            utmParameters: auth.utmParameters
          }, { responseContentType: 'application/json' });
        }).then(function (result) {
          return result;
        });
      }
    });
  };
}

function setPassword(password, token, language) {
  return function (dispatch, getState) {
    return dispatch({
      types: [SET_PASSWORD, SET_PASSWORD_SUCCESS, SET_PASSWORD_FAIL],
      promise: function promise(createLoginClient) {
        return createLoginClient().then(function (loginClient) {
          return loginClient.user.setPassword({
            encryptedToken: encodeURIComponent(token),
            languageTag: language,
            clientId: getState().auth.clientId,
            password: password
          }, { responseContentType: 'application/json' });
        }).then(function (result) {
          return result;
        });
      }
    });
  };
}

function createPassword(token, password, language) {
  return function (dispatch, getState) {
    return dispatch({
      types: [CREATE_PASSWORD, CREATE_PASSWORD_SUCCESS, CREATE_PASSWORD_FAIL],
      promise: function promise(createLoginClient) {
        return createLoginClient().then(function (loginClient) {
          return loginClient.user.createPassword({
            encryptedToken: encodeURIComponent(token),
            password: password,
            languageTag: language,
            clientId: getState().auth.clientId
          });
        });
      }
    });
  };
}

function startGracePeriod(operatorId) {
  return function (dispatch, getState) {
    return dispatch({
      types: [START_GRACE_PERIOD, START_GRACE_PERIOD_SUCCESS, START_GRACE_PERIOD_FAIL],
      promise: function promise(createLoginClient) {
        return createLoginClient().then(function (loginClient) {
          var auth = getState().auth;
          return loginClient.subscription.startGracePeriod({
            sessionId: auth.sessionId,
            operatorId: operatorId,
            deviceId: (0, _Cookie.readAndSaveDeviceId)(_config2.default.envPrefix, auth.realm),
            languageTag: auth.lang,
            clientId: auth.clientId
          }, { responseContentType: 'application/json' });
        }).then(function (result) {
          return result;
        });
      }
    });
  };
}

function editDropdown(value) {
  return { type: DROPDOWN_VALUE, value: value };
}

function editEmail(value) {
  return { type: EMAIL, value: value };
}

function editEmailMessageError(value) {
  return { type: EMAIL_ERROR_MESSAGE, value: value };
}

function editLanguage(lang, realm) {
  var cookieLang = _cookie2.default.serialize((0, _Cookie2.default)(_config2.default.envPrefix, _Cookie.currentLanguage, realm), lang, { expires: new Date((0, _moment2.default)().add(5, 'years').toDate()), path: _Cookie.rootPath });
  document.cookie = cookieLang;
  return { type: EDIT_LANGUAGE, lang: lang };
}

function editRememberMe(value) {
  return { type: REMEMBER_ME, value: value };
}

function qrLogin(response) {
  return { type: QR_LOGIN, response: response };
}

function editQrLoginState(response) {
  return { type: QR_LOGIN_STATE, response: response };
}

function editAutoGracePeriod(value) {
  return { type: AUTO_GRACE_PERIOD, value: value };
}

function editTermsAndPrivacy(value) {
  return { type: TERMS_PRIVACY, value: value };
}

function forceChooseProvider(value) {
  return { type: FORCE_CHOOSE_PROVIDER, value: value };
}

function setUtmParameters(utmParameters) {
  return { type: SET_UTM_PARAMETERS, utmParameters: utmParameters };
}

function setLocation(location) {
  return { type: SET_LOCATION, location: location };
}

function tvFlowStarted(tvCode, clientId, sessionId) {
  return { type: TV_FLOW_STARTED, tvCode: tvCode, clientId: clientId, sessionId: sessionId };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/auth.js
// module id = 22
// module chunks = 0